import { useQuery } from "@tanstack/react-query";
import { api } from "./api.ts";
import { keys } from "./query.ts";
import { useUiStore } from "../store/ui.ts";

/**
 * La sede que se está mirando, con su nombre.
 *
 * El id solo no alcanza para las pantallas que muestran números: un tablero
 * filtrado que no dice por qué está filtrado se lee como el total de la
 * organización, y esa confusión es peor que no poder filtrar. Cada pantalla
 * que acota por sede tiene que poder decirlo con el nombre a la vista.
 *
 * `null` es "todas", que es lo normal y no necesita aclaración.
 */
export function useActiveLocation(): {
  id: string | null;
  name: string | null;
} {
  const id = useUiStore((s) => s.activeLocationId);
  const { data: locations = [] } = useQuery({
    queryKey: keys.locations,
    queryFn: api.locations.list,
    // Con una sola sede nada de esto se muestra, y la lista ya viene pedida
    // por la barra lateral: esto se cuelga de la misma caché.
    enabled: Boolean(id),
  });
  if (!id) return { id: null, name: null };
  return { id, name: locations.find((l) => l.id === id)?.name ?? null };
}
